export default {
  // Hero Section
  'hero.badge': 'Cổng Vào Thị Trường Baltic & Bắc Âu',
  'hero.title.line1': 'Xuất Khẩu Hàng ',
  'hero.title.highlight1': 'Á Châu',
  'hero.title.line2': 'Sang',
  'hero.title.highlight2': 'Baltic & Bắc Âu',
  'hero.title.line3': 'Thị Trường',
  'hero.description': 'The Daeg International Trade - Đối tác tin cậy giúp doanh nghiệp Á Châu tiếp cận thị trường Baltic và Bắc Âu với hơn 5 triệu dân qua Latvia. Tận dụng lợi thế logistics và chi phí thấp trong phân khúc Bắc Âu.',
  'hero.stats.population': 'Dân Số Baltic & Bắc Âu',
  'hero.stats.experience': 'Năm Kinh Nghiệm',
  'hero.stats.locations': 'Trung Tâm Phân Phối',
  'hero.stats.support': 'Hỗ Trợ Toàn Diện',
  'hero.cta.contact': 'Liên Hệ Hợp Tác',
  'hero.cta.learn': 'Tìm Hiểu Thêm',

  // Opportunity Section
  'opportunity.title': 'Tại Sao Xuất Khẩu Sang Baltic & Bắc Âu Qua Latvia?',
  'opportunity.description': 'Latvia là cổng vào lý tưởng cho doanh nghiệp Á Châu tiếp cận thị trường Baltic và Bắc Âu với dân số hơn 30 triệu người.',
  'opportunity.item1.title': 'Vị Trí Chiến Lược',
  'opportunity.item1.desc': 'Latvia nằm ở trung tâm Baltic, thuận tiện tiếp cận thị trường Estonia, Lithuania và Bắc Âu.',
  'opportunity.item2.title': 'Chi Phí Logistics Thấp',
  'opportunity.item2.desc': 'Chi phí logistics cạnh tranh so với các nước Bắc Âu khác, giúp tối ưu lợi nhuận kinh doanh.',
  'opportunity.item3.title': 'Thị Trường Đang Phát Triển',
  'opportunity.item3.desc': 'Thị trường Baltic và Bắc Âu có dân số hơn 30 triệu với sức mua cao và nhu cầu hàng Á Châu ngày càng tăng.',
  'opportunity.item4.title': 'Thành Viên EU',
  'opportunity.item4.desc': 'Latvia là thành viên EU, dễ dàng phân phối hàng hóa ra toàn thị trường châu Âu mà không có rào cản thuế quan.',

  'opportunity.latvia.title': 'Thế Mạnh Của Latvia',
  'opportunity.latvia.desc.short': 'Cảng biển Riga — một trong những cảng lớn nhất Baltics. Chi phí vận hành <strong>thấp hơn 30–40%</strong> so với Bắc Âu, giúp doanh nghiệp <strong>tối ưu chi phí</strong> khi tiếp cận thị trường hơn 30 triệu dân.',
  'opportunity.latvia.desc.full': 'Latvia sở hữu <strong>hệ thống logistics hiện đại</strong> với cảng biển Riga — một trong những cảng lớn nhất vùng Baltics. Chi phí thuê mặt bằng, nhân công và vận hành <strong>thấp hơn 30–40%</strong> so với các nước Bắc Âu như Thụy Điển, Na Uy, Phần Lan. Đây là lợi thế cạnh tranh lớn cho doanh nghiệp muốn <strong>tối ưu chi phí</strong> trong khi vẫn tiếp cận được thị trường Bắc Âu giàu có với hơn 30 triệu dân.',

  // Services Section
  'services.title': 'Dịch Vụ Xuất Khẩu Toàn Diện',
  'services.description': 'Chúng tôi cung cấp giải pháp trọn gói từ nhập khẩu, phân phối đến logistics và hỗ trợ pháp lý.',
  'services.service1.title': 'Nhập Khẩu & Thông Quan',
  'services.service1.desc': 'Dịch vụ thông quan chuyên nghiệp, đảm bảo hàng hóa được nhập khẩu nhanh chóng và hợp pháp.',
  'services.service1.feature1': 'Hoàn tất thủ tục hải quan',
  'services.service1.feature2': 'Tư vấn VAT và thuế',
  'services.service1.feature3': 'Hỗ trợ chứng nhận sản phẩm',
  'services.service1.feature4': 'Thời gian xử lý nhanh',
  'services.service2.title': 'Phân Phối Qua Chợ Hẻm',
  'services.service2.desc': 'Phân phối sản phẩm qua hệ thống Asian Alley và Kiosk Chợ Hẻm của chúng tôi tại Riga.',
  'services.service2.feature1': '2 trung tâm phân phối',
  'services.service2.feature2': 'Vị trí đắc địa',
  'services.service2.feature3': 'Lượng khách đa dạng',
  'services.service2.feature4': 'Quản lý chuyên nghiệp',
  'services.service3.title': 'Logistics & Kho Bãi',
  'services.service3.desc': 'Hệ thống kho bãi hiện đại và dịch vụ logistics chuyên nghiệp.',
  'services.service3.feature1': 'Lưu trữ an toàn',
  'services.service3.feature2': 'Quản lý tồn kho',
  'services.service3.feature3': 'Giao hàng nhanh chóng',
  'services.service3.feature4': 'Chi phí cạnh tranh',
  'services.service4.title': 'Tư Vấn Pháp Lý & Thuế',
  'services.service4.desc': 'Dịch vụ tư vấn pháp lý và thuế để đảm bảo tuân thủ quy định của Latvia và EU.',
  'services.service4.feature1': 'Đăng ký doanh nghiệp',
  'services.service4.feature2': 'Tư vấn thuế',
  'services.service4.feature3': 'Hỗ trợ hợp đồng',
  'services.service4.feature4': 'Tuân thủ pháp luật',
  'services.service5.title': 'Nghiên Cứu Thị Trường',
  'services.service5.desc': 'Dịch vụ nghiên cứu và phân tích thị trường giúp bạn hiểu rõ nhu cầu khách hàng.',
  'services.service5.feature1': 'Phân tích thị trường',
  'services.service5.feature2': 'Nghiên cứu đối thủ',
  'services.service5.feature3': 'Chiến lược giá',
  'services.service5.feature4': 'Dự báo xu hướng',
  'services.service6.title': 'Hỗ Trợ 24/7',
  'services.service6.desc': 'Đội ngũ hỗ trợ tận tâm sẵn sàng giúp đỡ bạn bất cứ lúc nào.',
  'services.service6.feature1': 'Hỗ trợ đa ngôn ngữ',
  'services.service6.feature2': 'Phản hồi nhanh chóng',
  'services.service6.feature3': 'Tư vấn chuyên nghiệp',
  'services.service6.feature4': 'Đồng hành lâu dài',

  // Asian Alley Section
  'asianAlley.title': 'Chợ Hẻm - Hệ Thống Phân Phối Hàng Á Châu',
  'asianAlley.description': 'Chợ Hẻm là hệ thống phân phối hàng Á Châu của chúng tôi với 2 địa điểm tại Riga, phục vụ hàng nghìn khách hàng mỗi tháng.',
  'asianAlley.badge': 'Kênh Phân Phối Độc Quyền',
  'asianAlley.subtitle': 'Siêu Thị Châu Á Hàng Đầu Riga',
  'asianAlley.description2': 'Không chỉ là điểm bán lẻ, Asian Alley còn là <strong>showroom sống</strong> giúp đối tác kiểm chứng phản hồi thị trường thực tế, từ đó điều chỉnh sản phẩm phù hợp với khẩu vị và nhu cầu người tiêu dùng Châu Âu.',
  'asianAlley.callout.title': 'Lợi thế độc quyền:',
  'asianAlley.callout.desc': 'Đối tác của The Daeg được ưu tiên trưng bày tại Asian Alley — kênh phân phối duy nhất chuyên hàng Châu Á tại Latvia.',
  'asianAlley.stats.locations': 'Địa Điểm',
  'asianAlley.stats.revenue': 'Doanh Thu Năm',
  'asianAlley.stats.customers': 'Khách Hàng/Tháng',
  'asianAlley.stats.products': 'Ngành Hàng',
  'asianAlley.stats.locationsSub': 'Tại trung tâm Riga',
  'asianAlley.stats.customersSub': 'Người tiêu dùng thực tế',
  'asianAlley.stats.productsSub': 'Đa dạng danh mục',
  'asianAlley.stats.revenueSub': 'Tăng trưởng ổn định',
  'asianAlley.cta': 'Tìm Hiểu Thêm Về Chợ Hẻm',

  // Process Section
  'process.title': 'Quy Trình Xuất Khẩu',
  'process.description': 'Quy trình đơn giản và minh bạch, giúp bạn dễ dàng xuất khẩu hàng hóa sang thị trường Baltic và Bắc Âu.',
  'process.step1.title': 'Liên Hệ & Tư Vấn',
  'process.step1.desc': 'Liên hệ với chúng tôi để được tư vấn chi tiết về sản phẩm và quy trình xuất khẩu.',
  'process.step2.title': 'Đánh Giá Sản Phẩm',
  'process.step2.desc': 'Chúng tôi đánh giá sản phẩm và đưa ra phân tích thị trường, chiến lược giá.',
  'process.step3.title': 'Ký Hợp Đồng',
  'process.step3.desc': 'Ký hợp đồng hợp tác và thống nhất các điều khoản.',
  'process.step4.title': 'Nhập Khẩu & Thông Quan',
  'process.step4.desc': 'Chúng tôi xử lý thủ tục nhập khẩu và thông quan hàng hóa.',
  'process.step5.title': 'Phân Phối',
  'process.step5.desc': 'Sản phẩm được phân phối qua Chợ Hẻm hoặc các kênh khác.',
  'process.step6.title': 'Thanh Toán & Báo Cáo',
  'process.step6.desc': 'Thanh toán minh bạch và báo cáo chi tiết hàng tháng.',

  // Why Us Section
  'whyUs.title': 'Tại Sao Chọn The Daeg International Trade?',
  'whyUs.description': 'Chúng tôi là đối tác tin cậy với hơn 5 năm kinh nghiệm trong lĩnh vực xuất khẩu hàng Á Châu.',
  'whyUs.reason1.title': 'Kinh Nghiệm Dày Dặn',
  'whyUs.reason1.desc': 'Hơn 5 năm kinh nghiệm trong lĩnh vực xuất khẩu và phân phối hàng Á Châu tại thị trường Baltic và Bắc Âu.',
  'whyUs.reason2.title': 'Hệ Thống Phân Phối Sẵn Có',
  'whyUs.reason2.desc': 'Hệ thống phân phối Chợ Hẻm với 2 địa điểm tại Riga và Liepaja, phục vụ hàng nghìn khách hàng mỗi tháng.',
  'whyUs.reason3.title': 'Đội Ngũ Chuyên Nghiệp',
  'whyUs.reason3.desc': 'Đội ngũ giàu kinh nghiệm với kiến thức sâu về thị trường Baltic và Bắc Âu.',
  'whyUs.reason4.title': 'Chi Phí Cạnh Tranh',
  'whyUs.reason4.desc': 'Chi phí logistics và phân phối cạnh tranh, giúp tối ưu lợi nhuận kinh doanh.',
  'whyUs.reason5.title': 'Hỗ Trợ Toàn Diện',
  'whyUs.reason5.desc': 'Hỗ trợ đầy đủ từ nhập khẩu, phân phối đến tư vấn pháp lý và thuế.',
  'whyUs.reason6.title': 'Đồng Hành Lâu Dài',
  'whyUs.reason6.desc': 'Chúng tôi cam kết đồng hành lâu dài và phát triển bền vững cùng đối tác.',

  // Contact Section
  'contact.title': 'Sẵn Sàng Xuất Khẩu Sang Baltic & Bắc Âu?',
  'contact.description': 'Liên hệ với chúng tôi ngay hôm nay để được tư vấn chi tiết về dịch vụ xuất khẩu.',
  'contact.form.name': 'Họ và Tên',
  'contact.form.namePlaceholder': 'Nhập họ và tên của bạn',
  'contact.form.company': 'Tên Công Ty',
  'contact.form.companyPlaceholder': 'Nhập tên công ty của bạn',
  'contact.form.phone': 'Số Điện Thoại',
  'contact.form.phonePlaceholder': 'Nhập số điện thoại của bạn',
  'contact.form.email': 'Email',
  'contact.form.emailPlaceholder': 'Nhập email của bạn',
  'contact.form.product': 'Ngành Hàng',
  'contact.form.productPlaceholder': 'Nhập ngành hàng bạn muốn xuất khẩu',
  'contact.form.message': 'Tin Nhắn',
  'contact.form.messagePlaceholder': 'Cho chúng tôi biết về nhu cầu xuất khẩu của bạn...',
  'contact.form.submit': 'Gửi Yêu Cầu',
  'contact.form.submitting': 'Đang gửi...',
  'contact.success': 'Gửi yêu cầu thành công! Chúng tôi sẽ liên hệ với bạn sớm.',
  'contact.error': 'Đã xảy ra lỗi. Vui lòng thử lại.',

  // Export Services Section
  'services.sectionTitle': 'Giải Pháp Trọn Gói',
  'services.sectionTitleHighlight': 'Cho Đối Tác Xuất Khẩu',

  // Export Process Section
  'process.sectionTitle': '6 Bước Đơn Giản Để',
  'process.sectionTitleHighlight': 'Xuất Khẩu Sang EU',
  'process.stepLabel': 'Bước',
  'process.stepOf': '/',
  'process.prevBtn': 'Trước',
  'process.nextBtn': 'Tiếp',
  'process.step1.duration': '1-3 ngày',
  'process.step2.duration': '3-5 ngày',
  'process.step3.duration': '7-14 ngày',
  'process.step4.duration': '15-30 ngày',
  'process.step5.duration': 'Liên tục',
  'process.step6.duration': 'Từ tháng 3+',
  'process.timelineNote': 'Tổng thời gian từ ký hợp đồng đến hàng vào kho:',
  'process.timelineValue': 'chỉ 30-45 ngày',

  // Export Contact Section
  'contact.badge': 'Liên Hệ Hợp Tác',
  'contact.formTitle': 'Đăng Ký Hợp Tác Xuất Khẩu',
  'contact.formSubtitle': 'Tư vấn miễn phí — Không ràng buộc',
  'contact.hotlineLabel': 'Hotline Hợp Tác',
  'contact.hotlineSub': 'Whatsapp / Call / Viber',
  'contact.emailSub': 'Phản hồi trong 24h',
  'contact.officeLabel': 'Văn Phòng',
  'contact.officeSub': 'Riga, Latvia, EU',
  'contact.commitmentTitle': 'Cam Kết Của Chúng Tôi',
  'contact.commitmentQuote': 'Chúng tôi không chỉ là nhà nhập khẩu — chúng tôi là đối tác chiến lược, đồng hành cùng doanh nghiệp Châu Á xây dựng thương hiệu bền vững tại thị trường Châu Âu 450 triệu dân.',
  'contact.companyEstablished': 'Riga, Latvia — Est. 2019',
  'contact.form.country': 'Quốc Gia',
  'contact.form.countryPlaceholder': 'Chọn quốc gia',
  'contact.form.volume': 'Sản Lượng Xuất Khẩu Dự Kiến',
  'contact.form.volumePlaceholder': 'Chọn sản lượng',
  'contact.form.privacyNote': 'Bằng cách gửi form, bạn đồng ý để chúng tôi liên hệ tư vấn. Thông tin được bảo mật tuyệt đối.',
  'contact.countries.vietnam': 'Việt Nam',
  'contact.countries.china': 'Trung Quốc',
  'contact.countries.thailand': 'Thái Lan',
  'contact.countries.japan': 'Nhật Bản',
  'contact.countries.korea': 'Hàn Quốc',
  'contact.countries.indonesia': 'Indonesia',
  'contact.countries.malaysia': 'Malaysia',
  'contact.countries.philippines': 'Philippines',
  'contact.countries.india': 'Ấn Độ',
  'contact.countries.other': 'Khác',
  'contact.categories.food': 'Thực phẩm & Đồ uống',
  'contact.categories.spices': 'Gia vị & Nước chấm',
  'contact.categories.noodles': 'Mì & Bún khô',
  'contact.categories.snacks': 'Snack & Bánh kẹo',
  'contact.categories.consumer': 'Hàng tiêu dùng',
  'contact.categories.cosmetics': 'Mỹ phẩm & Chăm sóc cá nhân',
  'contact.categories.household': 'Hàng gia dụng',
  'contact.categories.other': 'Khác',
  'contact.volumes.under1': 'Dưới 1 container/tháng',
  'contact.volumes.1to3': '1-3 container/tháng',
  'contact.volumes.3to5': '3-5 container/tháng',
  'contact.volumes.over5': 'Trên 5 container/tháng',
};